import React from 'react'
import ReactDOM from 'react-dom/client'
// Initialize Echo before any components that might use it
import './services/echo'
import App from './App.jsx'
import './index.css'
import './styles/global.css'
import "./i18n";
import * as serviceWorkerRegistration from './services/registerServiceWorker'

// Synchronously capture token from URL for WebView Mobile Authentication Bridge before React Mounts
const currentUrlParams = new URLSearchParams(window.location.search);
const webviewToken = currentUrlParams.get('token');
const webviewRefreshToken = currentUrlParams.get('refresh_token');

if (webviewToken) {
  // Mobile app injected token found. Seed local storage immediately!
  localStorage.setItem('access_token', webviewToken);
  if (webviewRefreshToken) {
    localStorage.setItem('refresh_token', webviewRefreshToken);
  }
}

ReactDOM.createRoot(document.getElementById('root')).render(
  <App />,
)

// Register service worker for image caching and offline support
// Register service worker for image caching and offline support
// serviceWorkerRegistration.register({
//   onSuccess: () => {
//     console.log('[App] Service Worker registered - offline image caching enabled')
//   },
//   onUpdate: (registration) => {
//     console.log('[App] New service worker available, will update on next reload')
//   },
//   autoUpdate: false
// })

serviceWorkerRegistration.unregister();
